import {
  callApiAsync,
  downloadWalletZip,
  getProductLine,
  getWalletHistory,
  postWalletUpload,
  walletPreflight
} from "../../services/apiService";
import { downloadBlob } from "../../utils/downloadUtils";

export const postWalletUploadDATA = async (
  { year, month, businessLine, documentType, files, userId },
  onSuccess,
  onError
) => {
  const fd = new FormData();
  fd.append("year", year);
  fd.append("month", month);
  fd.append("businessLine", businessLine || "SerAnest");
  fd.append("documentType", documentType || "Cartera mensual");

  fd.append("carteraMesActual", files.carteraMesActual);
  fd.append("ventasAnoActual", files.ventasAnoActual);
  if (files.ventasAnoAnterior) fd.append("ventasAnoAnterior", files.ventasAnoAnterior);

  try {
    const resp = await postWalletUpload(fd, userId);
    const data = resp?.data ?? resp;
    onSuccess?.(data);
  } catch (err) {
    onError?.(err);
  }
};

export const getWalletHistoryDATA = async (
  year,
  month,
  lineId,      
  page,
  pageSize,
  setData,
  setTotal,
  setPage,
  userId
) => {
  if (!year || !month) return;

  await callApiAsync(
    () => getWalletHistory(year, month, lineId, page, pageSize, userId),
    (resp) => {
      const data = resp?.data ?? resp;

      setData(Array.isArray(data.items) ? data.items : []);
      setTotal(Number(data.total) || 0);
      setPage(Number(data.page) || page);
    }
  );
};
export const getWalletLinesDATA = async (setLineOptions, userId) => {
  await callApiAsync(
    () => getProductLine(userId),
    (data) => {
      const items = data?.items || [];
      const opts = [{ name: "Todas", value: "null" }, ...items];
      setLineOptions(opts);
    },
    () => {}
  );
};


export const downloadWalletZipDATA = async (id, year, month, lineId, userId) => {
  try {
    const resp = await downloadWalletZip(id, userId);

    const blob = resp?.data instanceof Blob ? resp.data : new Blob([resp.data], { type: "application/zip" });

    const fileName = `wallet_${String(month).padStart(2, "0")}_${year}_line_${lineId && lineId !== "null" ? lineId : "ALL"}.zip`;

    downloadBlob(blob, fileName);
    return true;
  } catch (err) {
    console.error("❌ downloadWalletZipDATA error:", err);
    return false;
  }
};

export const walletPreflightDATA = async (payload, onOk, userId) => {
  await callApiAsync(
    () => walletPreflight(payload, userId),
    (resp) => {
      const data = resp?.data ?? resp;
      onOk?.(data);
    }
  );
};
